// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge-3CBM0","badge_active":"badge_active-2YPBq"};